<button
  mat-icon-button
  [matTooltipPosition]="tooltipPosition"
  [matTooltip]="state.isActive ? 'Close' : 'Share'"
  class="button-share-asset bg-background-primary"
  [class.active]="state.isActive"
  [attr.data-test]="'button-share-asset-' + path"
  (click)="openInAssetSidebar($event)"
>
  <fa-icon class="fs-08" [icon]="['fal', 'share-from-square']"></fa-icon>
</button>
